<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 17.583 21.075">
        <g id="user" transform="translate(0 0)">
            <path id="Path_70126" data-name="Path 70126" d="M92.108,10.152A4.912,4.912,0,0,0,95.7,8.665a4.911,4.911,0,0,0,1.487-3.589A4.912,4.912,0,0,0,95.7,1.487a5.075,5.075,0,0,0-7.178,0,4.912,4.912,0,0,0-1.487,3.589,4.911,4.911,0,0,0,1.487,3.589A4.913,4.913,0,0,0,92.108,10.152Zm0,0" transform="translate(-83.449)" fill="#fff"/>
            <path id="Path_70127" data-name="Path 70127" d="M17.54,253.342a12.538,12.538,0,0,0-.171-1.332,10.492,10.492,0,0,0-.328-1.339,6.613,6.613,0,0,0-.55-1.249,4.712,4.712,0,0,0-.83-1.082,3.66,3.66,0,0,0-1.192-.749,4.121,4.121,0,0,0-1.522-.275,1.545,1.545,0,0,0-.825.35c-.247.161-.537.348-.859.554a4.925,4.925,0,0,1-1.112.49,4.318,4.318,0,0,1-2.72,0,4.912,4.912,0,0,1-1.111-.49c-.32-.2-.609-.391-.86-.554a1.543,1.543,0,0,0-.825-.35,4.115,4.115,0,0,0-1.522.276,3.657,3.657,0,0,0-1.192.749,4.713,4.713,0,0,0-.83,1.081,6.626,6.626,0,0,0-.55,1.249,10.516,10.516,0,0,0-.327,1.339,12.494,12.494,0,0,0-.171,1.332c-.028.4-.042.822-.042,1.245a3.5,3.5,0,0,0,1.039,2.648,3.742,3.742,0,0,0,2.678.977H13.865a3.741,3.741,0,0,0,2.678-.977,3.5,3.5,0,0,0,1.04-2.648c0-.425-.014-.844-.043-1.245Zm0,0" transform="translate(0 -237.136)" fill="#fff"/>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "IPersonFilled",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
